export const withoutHTMLTags = c => c.replace(/<\/?[^>]+(>|$)/g, '') || '...';

export default withoutHTMLTags;



// WEBPACK FOOTER //
// ./src/app/util/removeHtml.js